export const TempActionRequestConst = {
    tempActionAPI: 'api/TempAction',
    createTempAction: "/CreateTempAction",
    deleteTempAction: "/DeleteTempAction",
    downloadTempAction: "/DownLoadAttachment",
    getBlobFileDetail: 'api/Attachments/GetSASUriByFileName'
}